<template>
  <v-checkbox
    class="mt-0 pt-2 pl-1"
    hide-details
    :label="$t('insights.labels.allTime')"
    type="checkbox"></v-checkbox>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style scoped></style>
